<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container fluid>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.name"
                    name="name"
                    label="Name"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.code"
                    counter="4"
                    maxLength="4"
                    name="code"
                    label="Code"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.rfid"
                    name="rfid"
                    label="RFID"
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.location"
                    name="location"
                    label="Location"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <base-material-tabs color="success" icons-and-text>
                    <v-tab v-for="(tab, i) in tabs" :key="i" class="mb-5">
                      {{ tab.text }}
                      <v-icon v-text="tab.icon" />
                    </v-tab>

                    <v-tab-item>
                      <AppStepsForm
                        :readOnly="!canCreate && !canEdit"
                        v-bind:items.sync="resource.appSteps"
                        :chemicals="chemicals"
                      />
                    </v-tab-item>
                    <v-tab-item>
                      <AppPermissionsForm
                        :readOnly="!canCreate && !canEdit"
                        v-bind:items.sync="resource.appPermissions"
                        :plantUsers="plantUsers"
                      />
                    </v-tab-item>
                    <v-tab-item>
                      <DailyUsageForm
                        :readOnly="!canCreate && !canEdit"
                        v-bind:usage.sync="resource.expectedDailyUsage"
                      />
                    </v-tab-item>
                  </base-material-tabs>
                </v-col>
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash';
import Formable from '@/mixins/formable';

export default {
  mixins: [Formable],
  components: {
    AppStepsForm: () => import('@/components/forms/ApplicationStepForm.vue'),
    AppPermissionsForm: () => import('@/components/forms/ApplicationPermissionForm.vue'),
    DailyUsageForm: () => import('@/components/forms/DailyUsageForm.vue'),
  },
  props: {
    chemicals: {
      type: Array,
      default() {
        return [];
      },
    },
    plantUsers: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      resourceName: 'App',
      tab: 0,
      tabs: [
        {
          text: 'Steps',
          icon: 'mdi-file-document-edit',
        },
        {
          text: 'Permissions',
          icon: 'mdi-safe-square-outline',
        },
        {
          text: 'Usage',
          icon: 'mdi-chart-line',
        },
      ],
    };
  },
  computed: {
    isValid() {
      return !!(
        this.resource.name &&
        this.resource.code &&
        this.resource.location &&
        this.resource.appSteps.length &&
        _.every(this.resource.appSteps, this.appStepIsValid)
      );
    },
  },
  methods: {
    appStepIsValid(step) {
      return (
        step.toDelete ||
        (!_.isNil(step.dispenseType) &&
          !_.isNil(step.chemical) &&
          (parseFloat(step.gallons) ||
            parseFloat(step.ounces) ||
            parseFloat(step.weight) ||
            parseFloat(step.minutes) ||
            parseFloat(step.seconds)))
      );
    },
  },
};
</script>

<style lang="scss">
.v-tabs .v-item-group .v-slide-group__wrapper {
  margin-left: 14px;
}
</style>
